import React, { PureComponent } from 'react'
import PropTypes from 'prop-types'
import Glyph from 'component/utils/Glyph'
import { MODAL_TYPE } from './Modal'
import { DEPARTMENTS } from 'constants/config'

export default class DatasheetManagementTable extends PureComponent {
  static propTypes = {
    current: PropTypes.number.isRequired,
    datasheetManagementList: PropTypes.array.isRequired,
    hideSpinner: PropTypes.func.isRequired,
    openModal: PropTypes.func.isRequired,
    showSpinner: PropTypes.func.isRequired,
    token: PropTypes.string.isRequired,
    translate: PropTypes.func.isRequired,
    sections: PropTypes.object
  }

  renderRows = (dm) => {
    const { openModal } = this.props

    const sectionIdNm = this.getName(dm, dm.subSectionId, 2)
    const subSectionIdNm = this.getName(dm, dm.typeId, 3)
    const typeIdNm = this.getName(dm, dm.subTypeId, 4)
    const subTypeIdNm = this.getName(dm, null, 5)

    return (
      <tr key={dm.idDatasheetManagement}>
        <td>{sectionIdNm}</td>
        <td>{subSectionIdNm}</td>
        <td>{typeIdNm}</td>
        <td>{subTypeIdNm}</td>
        {this.renderFormat(dm.datasheetFormat)}
        <td>
          <span
            onClick={() =>
              openModal(MODAL_TYPE.EDIT, {
                ...dm,
                sectionIdNm,
                subSectionIdNm,
                typeIdNm,
                subTypeIdNm,
              })
            }
            className='action-icon'
          >
            <Glyph type='pencil' color='primary' />
          </span>
          <span
            onClick={() => openModal(MODAL_TYPE.DELETE, dm)}
            className='action-icon'
          >
            <Glyph type='trash-can' color='default' />
          </span>
        </td>
      </tr>
    )
  }

  getName = (item, next, level) => {
    let section

    const { sections } = this.props

    switch (level) {
      case 2:
        section = (sections[level] || []).find(
          (section) => section.sectionId === item.sectionId
        )
        break
      case 3:
        section = (sections[level] || []).find(
          (section) =>
            section.sectionId === item.sectionId &&
            section.subSectionId === item.subSectionId
        )
        break
      case 4:
        section = (sections[level] || []).find(
          (section) =>
            section.sectionId === item.sectionId &&
            section.subSectionId === item.subSectionId &&
            section.typeId === item.typeId
        )
        break
      case 5:
        section = (sections[level] || []).find(
          (section) =>
            section.sectionId === item.sectionId &&
            section.subSectionId === item.subSectionId &&
            section.typeId === item.typeId &&
            section.subTypeId === item.subTypeId
        )
        break
      default:
        break
    }

    if (section) {
      const value = `${section[DEPARTMENTS[level]]} - ${section.description}`

      return next ? value : <strong>{value}</strong>
    }
    return ''
  }

  renderFormat = (datasheetFormat) => (
    <td>
      {datasheetFormat.map((df) => (
        <div key={df.idDatasheetFormat} className='format-container'>
          <strong>{df.nmDatasheetFormat}</strong>
        </div>
      ))}
    </td>
  )

  render() {
    const { datasheetManagementList, translate } = this.props

    return (
      <>
        <table>
          <thead>
            <tr>
              <th>
                {translate('mobile.punctual.adjust.sectionBlock.section')}
              </th>
              <th>
                {translate('mobile.punctual.adjust.sectionBlock.subSection')}
              </th>
              <th>{translate('mobile.punctual.adjust.sectionBlock.type')}</th>
              <th>
                {translate('mobile.punctual.adjust.sectionBlock.subType')}
              </th>
              <th>{translate('datasheetManagement.formats')}</th>
              <th>{translate('datasheetManagement.actions')}</th>
            </tr>
          </thead>
          <tbody>{datasheetManagementList.map(this.renderRows)}</tbody>
        </table>
      </>
    )
  }
}
